import { render, staticRenderFns } from "./MailInJob.vue?vue&type=template&id=2ddc51b2&scoped=true"
import script from "./MailInJob.vue?vue&type=script&lang=js"
export * from "./MailInJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc51b2",
  null
  
)

export default component.exports